/**
 * Format date
 *
 * @param {String} date
 * @param {String} format
 *
 * @return {String}
 */

import dayjs from 'dayjs';

import {
    DATE_FORMAT,
} from 'Constants';

export default function formatDate (date, format = DATE_FORMAT) {
    return dayjs().isValid(date) ? dayjs(date).format(format) : null;
}
